import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mode } from 'crypto-js';
import { GLSettingForShowModel, GLSettingModel } from 'src/app/models/Accounting/tGLSettingModel';
import { AppSettings } from 'src/app/shared/AppSettings';

@Injectable({
  providedIn: 'root'
})
export class GLSettingService {

  constructor(private http: HttpClient) {


  }

  baseurl: string = AppSettings.BaseURI;

  readonly pathName = '/tGLSetting';

  getAllDataByShopID(shopID: string) {
    return this.http.get<GLSettingModel[]>(this.baseurl + this.pathName + '/' + shopID);
  }

  getDataByShopIDAndCurrID(shopID: string, baseCurrID: string) {
    return this.http.get<GLSettingModel>(this.baseurl + this.pathName + '/edit/' + shopID + '/' + baseCurrID);

  }

  add(data: GLSettingModel) {
    return this.http.post<GLSettingModel>(this.baseurl + this.pathName, data);
  }

  delete(shopID: string) {
    return this.http.delete<GLSettingModel>(this.baseurl + this.pathName + '/' + shopID);
  }

  update(value: GLSettingModel) {
    return this.http.put<string>(this.baseurl + this.pathName, value);

  }

  checkDataExisted(shopID: string) {
    return this.http.get<string>(this.baseurl + this.pathName + '/search/' + shopID);
  }

}
